import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import Price from 'common/components/_base/Price';
import Image from 'common/components/_base/Image';
import RouteLink from 'common/components/_base/RouteLink';
import List from 'common/components/styleguide/List';

import { capfl } from 'common/utils/index';

import SS from 'common/components/product/_styles';
const S = {};

S.Title = styled.h5`
`;

S.Item = styled.li`
  background: ${({ theme }) => _.get(theme, 'page.background')};
  border: ${({ theme }) => _.get(theme, 'border.default.width')} ${({ theme }) => _.get(theme, 'border.default.style')} ${({ theme }) => _.get(theme, 'border.default.color')};
  border-radius: ${({ theme }) => _.get(theme, 'border.default.radius')};
  margin-bottom: 5px;
  &:hover {
    background: ${({ theme }) => _.get(theme, 'page.backgroundSecondary')};
  }
  &:last-child {
    margin: 0;
  }
`;

S.HardHookItem = styled(RouteLink)`
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
`;

S.ImageAndNameWrapper = styled.div`
  display: flex;
  align-items: center;
`;

S.ImageWrapper = styled.div`
  display: flex;
  width: 50px;
  height: 50px;
  overflow: hidden;
  border: none;
`;

S.Name = styled.span`
  color: ${({ theme }) => _.get(theme, 'colors.text')};
  display: inline-block;
  margin-left: 10px;
`;

const HardHooks = ({ t, data }) => {
  if (!_.isEmpty(data)) {
    return (
      <SS.Block>
        <S.Title>{capfl(t('hard hooks'))}</S.Title>
        {_.map(data, hook => {
          return (
            <List key={'hard-hook-' + hook.id} reset>
              {_.map(hook.hookedProducts, product => {
                return (
                  <S.Item key={'hard-hook-item-' + product.id}>
                    <S.HardHookItem route="product" params={{ id: product.urlTitle }}>
                        <S.ImageAndNameWrapper>
                          {product.photo ? (
                            <S.ImageWrapper>
                              <Image {...product.photo} size="50x50.jpg" lazyload={false} />
                            </S.ImageWrapper>
                          ) : (
                            ''
                          )}
                          <S.Name>{product.name}</S.Name>
                        </S.ImageAndNameWrapper>
                        <Price
                          finalPrice={product.finalPrice}
                          finalPriceWithoutDPH={product.finalPriceWithoutDPH}
                          price={product.price}
                        />  
                    </S.HardHookItem>
                  </S.Item>
                );
              })}
            </List>
          );
        })}   
      </SS.Block>
    );
  }
  return null;
};

export default withTranslation()(HardHooks);
